import React from 'react';
import styled from 'styled-components';

type AlertComponentProps = {
  children: string
  level: 'success' | 'error'
}

const AlertStyle = styled.div<{$level: 'success' | 'error'}>`
  border-radius: 4px;
  font-size: 14px;
  margin: 10px 0 10px;
  padding: 10px;
  ${props => {
    switch (props.$level) {
      case 'success':
        return `
          background: #d1e7dd;
          border: 1px solid #badbcc;
          color: #0f5132;
      `;
      case 'error':
        return `
          background: #f8d7da;
          border: 1px solid #f5c2c7;
          color: #842029;
      `;
    }
  }}
`;

const Alert: React.FC<AlertComponentProps> = ({ children, level }) => {
  return (
    <AlertStyle $level={level}>
      { children }
    </AlertStyle>
  );
};

export default Alert;
